import { buildLockedCommercialDecision } from "../../../utils/commercialCapabilities";

export const POST_ANALYSIS_SUCCESS_STORAGE_PREFIX = "verdictia:first-analysis-success";

const firstPresent = (...values) => (
    values
        .map((value) => String(value ?? "").trim())
        .find(Boolean) || ""
);

export const getPostAnalysisSuccessStorageKey = (user = {}) => {
    const userId = firstPresent(user?.id, user?.user_id, user?.uuid);
    if (!userId) return null;

    const clientId = firstPresent(
        user?.client_id,
        user?.clientId,
        user?.workspace_id,
        user?.client?.id,
        user?.client?.uuid,
        "workspace"
    );

    return `${POST_ANALYSIS_SUCCESS_STORAGE_PREFIX}:${clientId}:${userId}`;
};

export const hasSeenPostAnalysisSuccessCard = (storage, storageKey) => {
    if (!storage || !storageKey) return false;
    try {
        return storage.getItem(storageKey) === "1";
    } catch (_) {
        return false;
    }
};

export const markPostAnalysisSuccessCardSeen = (storage, storageKey) => {
    if (!storage || !storageKey) return;
    try {
        storage.setItem(storageKey, "1");
    } catch (_) {}
};

export const shouldShowPostAnalysisSuccessCard = ({
    commentsCount,
    iaStreaming,
    seen,
    storageKey,
} = {}) => (
    Boolean(storageKey)
    && Number(commentsCount) > 0
    && iaStreaming !== true
    && seen !== true
);

export const buildPostAnalysisOffersDecision = () => buildLockedCommercialDecision("contract_profile_advanced", {
    code: "first_analysis_success_upgrade_prompt",
    titleFr: "Fonctions de revue avancée",
    bodyFr: "Votre revue est prête. Les offres supérieures ajoutent le mémo, les exports et les analyses avancées selon les droits de votre workspace.",
    titleEn: "Advanced features available",
    bodyEn: "Your review is ready. Higher plans add memo, export and advanced analysis features according to your workspace rights.",
    ctaFr: "Voir les offres",
    ctaEn: "View plans",
    metadata_json: {
        source: "first_analysis_success_card",
    },
});
